module.exports = __webpack_public_path__ + "img/03 Animation 2-squashed.9fac44f7.jpg";